import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { Search } from '@material-ui/icons'
import { Typography, Grid, Divider, Button, FormControlLabel, Checkbox } from '@material-ui/core'
import { PfSubPfSelect, GameSelect, GameReportDatetimeSelect, CompleteDecimal } from '@select'
import { API, DATE } from '@const'
import * as utils from '@utils'
import { Decimal } from 'decimal.js'
import ComponentDialog from '@dialogs/component-dialog'
import { PlayerBetReportTable, Table } from '@tables'
import GameRoundResultPage from './game-round-result-page'

const COMPONENT_GROUP = 'game_report'

class GameReportPage extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'GameReportPage')
        }
    }

    state = {
        isRealTimeCaculation: false,
    }

    options = {
        export: false,
    }

    columns = [
        {
            field: 'game_name',
            translate: {
                tranKey: 'GameName',
                dataKey: 'game_code',
            },
        },
        {
            field: 'pf_sub_pf_id',
            type: 'platform',
        },
        {
            field: 'bet_player_amount',
            type: 'numberByThous',
            render: (rowData, display) =>
                rowData.game_code ? (
                    <Button
                        className={this.props.classes.linkButton}
                        onClick={() =>
                            this.compDialog.OpenDialog(
                                this.t('PlayerBetReportTable'),
                                <PlayerBetReportTable
                                    compDialogArgs={{
                                        dateUnit: this.props?.compDialogArgs?.dateUnit ?? 'minute',
                                        displayGameTypeCode: 'all',
                                        gameCode: rowData['game_code'],
                                        startDate: this.gameReportDatetimeSelect.state.startDate,
                                        endDate: this.gameReportDatetimeSelect.state.endDate,
                                        pfId: this.pfSelect.state.pfId,
                                        pfSubPfId:
                                            rowData['pf_sub_pf_id'] !== 'all'
                                                ? rowData['pf_sub_pf_id']
                                                : this.pfSelect.state.pfSubPfId !== 'all'
                                                    ? this.pfSelect.state.pfSubPfId
                                                    : '',
                                        exportType: 'list_pf_account'
                                    }}></PlayerBetReportTable>
                            )
                        }>
                        {display}
                    </Button>
                ) : (
                    display
                ),
        },
        {
            field: 'bet_amount',
            type: 'numberByThous',
            render: (rowData, display) => {
                return <Button
                className={this.props.classes.linkButton}
                onClick={() =>
                    this.compDialog.OpenDialog(
                        this.t('GameRoundResultPage'),
                        <GameRoundResultPage
                            compDialogArgs={{
                                dateUnit: this.props?.compDialogArgs?.dateUnit ?? 'minute',
                                searchType: 'date',
                                gameMaker: this.gameSelect.state.gameMaker,
                                displayGameTypeCode: 'all',
                                gameCode: rowData['game_code'],
                                startDate: this.gameReportDatetimeSelect.state.startDate,
                                endDate: this.gameReportDatetimeSelect.state.endDate,
                                pfId: this.pfSelect.state.pfId,
                                pfSubPfId:
                                    rowData['pf_sub_pf_id'] !== 'all'
                                        ? rowData['pf_sub_pf_id']
                                        : this.pfSelect.state.pfSubPfId !== 'all'
                                            ? this.pfSelect.state.pfSubPfId
                                            : '',
                            }}></GameRoundResultPage>
                    )
                }>
                {display}
            </Button>
            }
        },
        {
            field: 'bet',
            type: 'currency',
        },
        {
            field: 'buy_free_game_amount',
            type: 'numberByThous',
            render: (rowData, display) => {
                return <Button
                className={this.props.classes.linkButton}
                onClick={() =>
                    this.compDialog.OpenDialog(
                        this.t('GameRoundResultPage'),
                        <GameRoundResultPage
                            compDialogArgs={{
                                dateUnit: this.props?.compDialogArgs?.dateUnit ?? 'minute',
                                searchType: 'date',
                                gameMaker: this.gameSelect.state.gameMaker,
                                displayGameTypeCode: 'all',
                                gameCode: rowData['game_code'],
                                startDate: this.gameReportDatetimeSelect.state.startDate,
                                endDate: this.gameReportDatetimeSelect.state.endDate,
                                pfId: this.pfSelect.state.pfId,
                                purchase_method: 1,
                                pfSubPfId:
                                    rowData['pf_sub_pf_id'] !== 'all'
                                        ? rowData['pf_sub_pf_id']
                                        : this.pfSelect.state.pfSubPfId !== 'all'
                                            ? this.pfSelect.state.pfSubPfId
                                            : '',
                            }}></GameRoundResultPage>
                    )
                }>
                {display}
            </Button>
            }
        },
        {
            field: 'bet_valid',
            type: 'currency',
        },
        {
            field: 'operator_profit',
            type: 'currency',
            render: (row, display) => {
                const fontColor = row['operator_profit'] < 0 ? 'red' : ''
                return <div style={{ color: fontColor }}>{display}</div>
            },
        },
        {
            field: 'tax',
            type: 'currency',
        },
        {
            field: 'profit_rate',
            type: 'number',
            render: (_row, display) => {
                return this.handleNumberRender(display)
            }
        },
        {
            field: 'rtp',
            type: 'number',
            render: (_row, display) => {
                return this.handleNumberRender(display)
            }
        },
    ]

    dialogColumns = this.columns.filter((item) => item.field !== 'rtp' && item.field !== 'profit_rate')

    componentDidMount() {
        if (utils.checkValid(COMPONENT_GROUP + '.export')) {
            this.options.export = true
        }

        if (this.props.compDialogArgs) {
            const promiseList = []
            promiseList.push(
                new Promise((resolve) => {
                    this.gameReportDatetimeSelect.setState(
                        {
                            startDate: this.props.compDialogArgs.startDate,
                            endDate: this.props.compDialogArgs.endDate,
                        },
                        resolve
                    )
                })
            )

            promiseList.push(
                new Promise((resolve) => {
                    this.pfSelect.setState(
                        {
                            pfId: this.props.compDialogArgs.pfId,
                            pfSubPfId: this.props.compDialogArgs.pfSubPfId,
                        },
                        resolve
                    )
                })
            )

            promiseList.push(
                new Promise((resolve) => {
                    this.gameSelect.setState(
                        {
                            displayGameTypeCode: this.props.compDialogArgs.displayGameTypeCode,
                            gameCode: this.props.compDialogArgs.gameCode,
                        },
                        resolve
                    )
                })
            )

            Promise.all(promiseList).then(() => this.queryData())
        }
    }

    handleNumberRender(display) {
        if (typeof display !== 'number') {
            return null
        }

        const decimal = this.props.auth.isCompleteDecimal ? 6 : 2
        const number = display * 100; // 因為後端傳來是小數點, 所以先轉乘百分比在取小數點後兩位
        return <div>{`${utils.getDecimalPlaces(number, decimal)}%`}</div>
    }

    queryData() {
        this.table.SetLoading(true)
        this.sumTable.SetLoading(true)

        const dateUnit = this.props?.compDialogArgs?.dateUnit ?? 'minute'
        const start_date = this.props.compDialogArgs
            ? utils.datetimeToUnix_startOf(this.props.compDialogArgs.startDate, dateUnit)
            : utils.datetimeToUnix_startOf(this.gameReportDatetimeSelect.state.startDate, 'minute')
        const end_date = this.props.compDialogArgs
            ? utils.datetimeToUnix_endOf(this.props.compDialogArgs.endDate, dateUnit)
            : utils.datetimeToUnix_endOf(this.gameReportDatetimeSelect.state.endDate, 'minute')

        const queryParams = {
            pf_id: this.pfSelect.state.pfId !== 'all' ? this.pfSelect.state.pfId : '',
            pf_sub_pf_id: this.pfSelect.state.pfSubPfId !== 'all' ? this.pfSelect.state.pfSubPfId : '',
            display_game_type_code_id: this.gameSelect.state.displayGameTypeCode !== 'all' ? this.gameSelect.state.displayGameTypeCode : '',
            game_code: this.gameSelect.state.gameCode !== 'all' ? this.gameSelect.state.gameCode : '',
            start_date,
            end_date,
            is_real_time_caculation: this.state.isRealTimeCaculation,
            timezone: DATE.CLIENT_UTC_OFFSET,
        }
        /** 開發商不是全部時需攜帶查詢參數 */
        if (this.gameSelect.state.gameMaker !== 'all') {
            queryParams.maker = String(this.gameSelect.state.gameMaker)
        }
        /** 由其他頁面彈跳視窗開啟此頁面並攜帶額外apiUrl */
        const apiUrl = this.props?.compDialogArgs?.apiUrl || API.BET_RECORD_SUM_LIST_BY_GAME
        utils.apiRequest(
            'get',
            apiUrl,
            queryParams,
            (data) => {
                const currency = utils.getPfCurrency(queryParams['pf_id'])
                
                // 從彈窗開跟從頁面開設定資料的方式不同
                if (this.props.compDialogArgs) {
                    this.table.SetData(
                        // 彈窗開的話沒有 rtp 跟獲利率所以 format 帶空陣列
                        this.formatGameData(data.reports, []),
                        currency
                    )
                } else {
                    this.table.SetData(
                        this.formatGameData(data.reports, data.total_games),
                        currency
                    )
                    this.sumTable.SetData(this.formatPlatformData(data.sum_reports, data.total_sum_reports), currency)
                }
            },
            (_err) => {
                this.table.SetData(this.formatGameData([], []))
                this.sumTable.SetData(this.formatPlatformData([], []))
            },
            true
        )
    }

    formatGameData(data, total_games = []) {
        const display_game_type_code_id = this.gameSelect.state.displayGameTypeCode;
        const game_code = this.gameSelect.state.gameCode
        
        let tempList = []
        data.forEach((elem) => {
            tempList.push(utils.deepCopy(elem))
        })

        var sumPerGameCode = {}
        var count = 0
        tempList.sort((a, b) => utils.SortPlatform(a.pf_sub_pf_id, b.pf_sub_pf_id))

        /** 需要多篩選開發商 */
        utils.deepCopy(this.props.dataService.gameList)
            .filter(item => {
                return this.gameSelect.state.gameMaker === 'all' || String(this.gameSelect.state.gameMaker) === String(item.maker)
            })
            .forEach((item) => {
                if (
                    (display_game_type_code_id !== 'all' && display_game_type_code_id !== item.display_game_type_code_id) ||
                    (game_code !== 'all' && game_code !== item.game_code)
                ) {
                    // do nothing
                } else {
                    // 因為遊戲的rtp與獲利率總計在api是不同資料且是陣列, 所以先篩出對應在取值
                    const gamesTotal = total_games.find((totalItem) => totalItem.game_code === item.game_code) || {
                        game_code: item.game_code,
                        profit_rate: 0,
                        rtp: 0
                    }
                    sumPerGameCode[item.game_code] = {
                        bet_player_amount: 0,
                        bet_amount: 0,
                        bet: 0,
                        bet_valid: 0,
                        operator_profit: 0,
                        tax: 0,
                        game_code: item.game_code,
                        id: ++count,
                        pf_sub_pf_id: 'all',
                        rtp: gamesTotal.rtp,
                        profit_rate: gamesTotal.profit_rate,
                        buy_free_game_amount: 0
                    }
                }
            })

        tempList.forEach((item) => {
            if (sumPerGameCode[item.game_code] === undefined) {
                sumPerGameCode[item.game_code] = {
                    ...item,
                    id: ++count,
                    pf_sub_pf_id: 'all',
                }
            } else {
                Object.keys(sumPerGameCode[item.game_code]).forEach((key) => {
                    if (['id', 'game_code', 'pf_id', 'pf_sub_pf_id', 'rtp', 'profit_rate'].indexOf(key) === -1)
                        sumPerGameCode[item.game_code][key] = new Decimal(sumPerGameCode[item.game_code][key]).add(item[key])
                })
            }
            item.id = ++count
            item.parent = sumPerGameCode[item.game_code].id
        })
        tempList = tempList.concat(Object.values(sumPerGameCode))
        return tempList
    }

    formatPlatformData(data, total_sum_reports) {
        let tempList = []

        data.forEach((elem) => {
            tempList.push(utils.deepCopy(elem))
        })

        var sumPerDay = {}
        var count = 0
        tempList.sort((a, b) => utils.SortPlatform(a.pf_sub_pf_id, b.pf_sub_pf_id))
        tempList.forEach((item) => {
            if (sumPerDay[item.date] === undefined) {
                sumPerDay[item.date] = {
                    ...item,
                    id: ++count,
                    pf_sub_pf_id: 'all',
                    rtp: total_sum_reports.total_rtp,
                    profit_rate: total_sum_reports.total_profit_rate
                }
            } else {
                Object.keys(sumPerDay[item.date]).forEach((key) => {
                    if (['id', 'date', 'pf_id', 'pf_sub_pf_id', 'rtp', 'profit_rate'].indexOf(key) === -1)
                        sumPerDay[item.date][key] = new Decimal(sumPerDay[item.date][key]).add(item[key])
                })
            }
            item.id = ++count
            item.parent = sumPerDay[item.date].id
        })
        tempList = tempList.concat(Object.values(sumPerDay))

        if (tempList.length === 0)
            tempList.push({
                bet_player_amount: 0,
                bet_amount: 0,
                bet: 0,
                bet_valid: 0,
                operator_profit: 0,
                tax: 0,
                id: 0,
                pf_sub_pf_id: 'all',
                buy_free_game_amount: 0
            })

        return tempList
    }

    render() {
        return (
            <React.Fragment>
                <Grid container spacing={2} className={this.props.compDialogArgs ? this.props.classes.hide : ''}>
                    <GameReportDatetimeSelect onRef={(ref) => (this.gameReportDatetimeSelect = ref)} />
                    <GameSelect 
                        onRef={(ref) => (this.gameSelect = ref)} 
                        options={{gameMakerSelect: utils.checkValid('report.maker')}}
                    />
                    <PfSubPfSelect
                        onRef={(ref) => (this.pfSelect = ref)}
                        options={{
                            hideAllPlatform: true
                        }}
                    />
                    <Grid item xs={1} className={this.props.classes.alignCenter}>
                        <Button
                            variant="contained"
                            color="primary"
                            className={this.props.classes.button}
                            onClick={() => {
                                this.queryData()
                            }}>
                            <Search className={this.props.classes.rightIcon} />
                            {this.t('search')}
                        </Button>{' '}
                    </Grid>
                    { utils.checkValid('game_report.real_time') && (
                        <Grid item className={this.props.classes.alignCenter}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.state.isRealTimeCaculation}
                                        onChange={(event) => {
                                            this.gameReportDatetimeSelect.setState({
                                                // 切換時有勾選則不鎖, 反之
                                                isRealTimeCaculation: event.target.checked,
                                                startDate: utils.datetimeStartOfWithoutOffset(utils.currentDatetime(), 'day'),
                                                endDate: utils.datetimeEndOfWithoutOffset(utils.currentDatetime(), 'day'),
                                                endDateMax: event.target.checked
                                                ? utils.datetimeEndOfWithoutOffset(utils.currentDatetime(), 'day')
                                                : this.gameReportDatetimeSelect.handleMaxDate()
                                            })
                                            this.setState({
                                                isRealTimeCaculation: event.target.checked,
                                            })
                                        }}
                                        name="checked"
                                        color="primary"
                                    />
                                }
                                label={this.t('isRealTimeCaculation')}
                                className={this.props.classes.labelMarginClear}
                            />
                        </Grid>
                        )
                    }
                    <Grid item className={this.props.classes.alignCenter}>
                        <CompleteDecimal />
                    </Grid>
                    <Grid item xs={12}>
                        <Divider />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="h6">{this.t('total')}</Typography>
                        <Table
                            ownerName="GameReportPage"
                            columns={this.columns.slice(1)}
                            options={{ ...this.options, toolbar: false, paging: false }}
                            onRef={(ref) => (this.sumTable = ref)}
                            parentChildData={(row, rows) => {
                                return rows.find((a) => a.id === row.parent)
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Divider />
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Table
                            ownerName="GameReportPage"
                            columns={
                                this.props.compDialogArgs 
                                    ? this.dialogColumns 
                                    : this.columns
                            }
                            options={this.options}
                            parentChildData={(row, rows) => rows.find((a) => a.id === row.parent)}
                            onRef={(ref) => (this.table = ref)}
                        />
                    </Grid>
                    <ComponentDialog onRef={(ref) => (this.compDialog = ref)}></ComponentDialog>
                </Grid>
            </React.Fragment>
        )
    }
}

const styles = (theme) => {
    return {
        formControl: {
            margin: theme.spacing(1),
            width: '100%',
            minWidth: 120,
        },
        textField: {
            margin: theme.spacing(1),
            width: '100%',
            minWidth: 120,
        },
        button: {
            margin: theme.spacing(1),
        },
        rightIcon: {
            marginRight: theme.spacing(1),
        },
        hide: {
            display: 'none',
        },
        linkButton: {
            background: 'none!important',
            border: 'none',
            padding: '0!important',
            color: '#1890ff',
            textDecoration: 'none',
            cursor: 'pointer',
            userSelect: 'text',
            outline: 'none !important',
            '& span': {
                justifyContent: 'flex-end',
            }
        },
        alignCenter: {
            display: 'inline-flex',
            alignItems: 'center',
        },
        labelMarginClear: {
            margin: 0,
        },
    }
}

GameReportPage.propTypes = {
    classes: PropTypes.object.isRequired,
    auth: PropTypes.object,
    dataService: PropTypes.object,
    compDialogArgs: PropTypes.object,
}

export default hoc(styles)(GameReportPage)
